import { render, staticRenderFns } from "./AdvancedPagesSidebar.vue?vue&type=template&id=a632cb24&scoped=true"
import script from "./AdvancedPagesSidebar.vue?vue&type=script&lang=js"
export * from "./AdvancedPagesSidebar.vue?vue&type=script&lang=js"
import style0 from "./AdvancedPagesSidebar.vue?vue&type=style&index=0&id=a632cb24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a632cb24",
  null
  
)

export default component.exports